import * as React from "react";

;
export const ChevronRight = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.94 12L6.47 3.53l1.06-1.06L17.06 12l-9.53 9.53-1.06-1.06L14.94 12z" fill="#100722" /></svg>;